import { Map } from 'immutable';

import { getRetainFromVariations, updateTemplateForRetain } from '../../variations/retain';
import { getOperationsFromProduct } from '../../product/getOperationsFromProduct';
import { filterProfileOperations } from './profiles';
import { shapeProductForApp } from '../../product/shapeForApp';
import { formHasErrors } from '../../product/formHasErrors';

import { AMOUNT, NEW } from '../../../constants/product';
import { RETAIN } from '../../../constants/variations';
import { FORM } from '../../../constants/forms';
import { ALL } from '../../../constants/profiles';

export function setIsComplete({ sections, template }) {
  if (!template) return undefined;

  function reduceSections(valid, selected, section) {
    switch (section) {
      case ALL: {
        return valid;
      }

      default: {
        return selected
          ? valid && !formHasErrors({ product: template, type: section })
          : valid;
      }
    }
  }

  return template.set('isComplete', sections.reduce(reduceSections, true));
}

export function shapeTemplateForApp({ channel, data, sections, shopId, templateId: productId }) {
  const product = shapeProductForApp({ asProfile: true, channel, data, productId, shopId });
  const variations = product.get(FORM.VARIATIONS);
  const template = product.setIn([FORM.VARIATIONS, RETAIN], getRetainFromVariations({ channel, variations }));
  return setIsComplete({ sections, template });
}

export function getTemplateOperations({ channel, profile }) {
  function updateTemplate(source) {
    const template = updateTemplateForRetain({ channel, template: source });
    return template.set('operations', getOperationsFromProduct({ channel, product: template }));
  }

  return filterProfileOperations({ channel, profile: profile.update('template', updateTemplate) });
}

export function convertProductToTemplate({ channel, product }) {
  const variations = product.get(FORM.VARIATIONS).set('currentProfile', Map({ profileId: AMOUNT.MINUS_ONE }));
  const template = updateTemplateForRetain({
    channel,
    template: product.setIn([FORM.VARIATIONS, RETAIN], getRetainFromVariations({ channel, variations })),
  });

  return template.set('productId', NEW).set('operations', getOperationsFromProduct({ channel, product: template }));
}
